import React from 'react'
import { Link } from 'react-router-dom'
import { Modal, ModalActions } from '../../components/Modal'
import { InboxType } from '../../../server/models/Inbox'
import { CopyInput } from '../../components/Inputs/CopyInput'

type Props = {
  onRequestClose: () => void
  isOpen: boolean
  createdInbox?: InboxType
  loading: boolean
}

export const CreatedInboxSuccessModal: React.FC<Props> = ({
  onRequestClose,
  isOpen,
  createdInbox,
  loading
}) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose}>
      <h2>🚀 You're ready to go</h2>
      <CopyInput
        name="email"
        label="Click to copy this folder email address"
        type="email"
        value={createdInbox?.email ?? 'One moment...'}
      />
      <h4>Here's what you do next:</h4>
      <ul>
        <li>Forward newsletter emails to this address</li>
        <br />
        <li>Sign up for newsletters with this address</li>
      </ul>
      <h4>Ok, then what?</h4>
      <ul>
        <li>When an email comes in, content will be generated for each email. </li>
        <br />
        <li>Check the <Link to="/app/content">Content page</Link> soon as emails come in!</li>
      </ul>
      <ModalActions
        onSubmit={onRequestClose}
        loading={loading}
        submitText="Got it"
      />
    </Modal>
  )
}
